export default __webpack_public_path__ + "static/media/orgAlias.c6ededb4.svg";